"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInterstitial = void 0;
var useInterstitial_hook_1 = require("./useInterstitial.hook");
Object.defineProperty(exports, "useInterstitial", { enumerable: true, get: function () { return useInterstitial_hook_1.useInterstitial; } });
//# sourceMappingURL=index.js.map